const draftLifetime = 30 * 60 * 1000;
const draftFields = ['Enquiry reason', 'First name', 'Last name', 'Order number'];
const initializedForms = new WeakSet();

function initializeDrafts(root = document) {
  const markers = root.querySelectorAll('[data-thb-contact-draft]');
  for (const marker of markers) {
    const form = marker.closest('form');
    if (!form?.id || initializedForms.has(form)) continue;
    initializedForms.add(form);
    const key = `thb:contact:draft:v1:${location.pathname}:${form.id}`;
    let expiryTimer;
    let pendingSubmission;
    const clearDraft = () => {
      clearTimeout(expiryTimer);
      try { sessionStorage.removeItem(key); } catch {}
    };
    const scheduleExpiry = savedAt => {
      clearTimeout(expiryTimer);
      expiryTimer = setTimeout(clearDraft, Math.max(0, draftLifetime - (Date.now() - savedAt)));
    };
    const readDraft = () => {
      try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const draft = JSON.parse(raw);
        const age = Date.now() - draft.savedAt;
        if (draft.version !== 1 || !Number.isFinite(draft.savedAt) || age < 0 || age >= draftLifetime || !draft.values || typeof draft.values !== 'object' || Array.isArray(draft.values)) {
          clearDraft();
          return null;
        }
        if (Object.keys(draft.values).some(name => !draftFields.includes(name) || typeof draft.values[name] !== 'string' || draft.values[name].length > 2048)) {
          clearDraft();
          return null;
        }
        scheduleExpiry(draft.savedAt);
        return draft;
      } catch {
        clearDraft();
        return null;
      }
    };
    const fieldFor = name => {
      const field = form.elements.namedItem(`contact[${name}]`);
      return field instanceof HTMLInputElement || field instanceof HTMLSelectElement ? field : null;
    };
    const draft = readDraft();
    if (marker.dataset.thbContactDraftStatus === 'success') {
      clearDraft();
    } else if (marker.dataset.thbContactDraftStatus === 'error' && draft) {
      const error = [...form.querySelectorAll('.contact-form__error')].find(node => node.id === `${form.id}-email-error`);
      if (error && error.getClientRects().length && getComputedStyle(error).visibility !== 'hidden') {
        for (const name of draftFields) {
          const field = fieldFor(name);
          const value = draft.values[name];
          if (!field || field.disabled || field.value.trim() || typeof value !== 'string') continue;
          if (field instanceof HTMLSelectElement && ![...field.options].some(option => option.value === value)) continue;
          field.value = value;
        }
      }
    }
    form.addEventListener('submit', event => {
      if (event.defaultPrevented || !form.checkValidity()) return;
      const values = {};
      for (const name of draftFields) {
        const field = fieldFor(name);
        if (field && !field.disabled && field.value.length <= 2048) values[name] = field.value;
      }
      pendingSubmission = { event, values };
      setTimeout(() => { pendingSubmission = null; }, 0);
    });
    form.addEventListener('formdata', () => {
      if (!pendingSubmission || pendingSubmission.event.defaultPrevented) return;
      const { event, values } = pendingSubmission;
      pendingSubmission = null;
      if (!Object.values(values).some(value => value.trim())) {
        clearDraft();
        return;
      }
      const savedAt = Date.now();
      let previous;
      try {
        previous = sessionStorage.getItem(key);
        sessionStorage.setItem(key, JSON.stringify({ version: 1, savedAt, values }));
        scheduleExpiry(savedAt);
      } catch {}
      setTimeout(() => {
        if (!event.defaultPrevented) return;
        clearDraft();
        if (previous) {
          try { sessionStorage.setItem(key, previous); } catch {}
          readDraft();
        }
      }, 0);
    });
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeDrafts(), { once: true });
else initializeDrafts();

document.addEventListener('shopify:section:load', event => {
  if (event.target instanceof Element) initializeDrafts(event.target);
});
